import { render } from "./consultationDetailed.vue?vue&type=template&id=bec7bf82&scoped=true"
import script from "./consultationDetailed.vue?vue&type=script&lang=js"
export * from "./consultationDetailed.vue?vue&type=script&lang=js"

import "./consultationDetailed.vue?vue&type=style&index=0&id=bec7bf82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bec7bf82"

export default script